module.exports = __webpack_public_path__ + "img/twitter_coloerd.71698320.svg";